{
  "collectionLabel": "Návrhy"
}
